import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

import { TOfferSpendByOfferAggOnly, TOfferSpendByOfferDay, EOfferSpendByOfferView } from '../../types'
import { ToolPanel } from '../ui'
import { OfferSpendByOfferDetailsTable } from './OfferSpendByOfferDetailsTable'
import { ALL_LANG_KEY } from '../../types/lang'
import { useTranslation } from 'react-i18next'

type IOfferSpendByOfferDetailsModal = {
	viewBy: EOfferSpendByOfferView;
	offerSpend: TOfferSpendByOfferDay | TOfferSpendByOfferAggOnly | null;
	show: boolean;
	take: number | 'all';
	onClose: () => void;
}

export const OfferSpendByOfferDetailsModal = (
	props: IOfferSpendByOfferDetailsModal
) => {
	const { viewBy, offerSpend, show, take = 10, onClose } = props
	const { t } = useTranslation()
	const [page, setPage] = useState<number>(0)
	const skip = (take === 'all') ? 0 : page > 0 ? page * take : 0

	const isSingleView = !!(offerSpend && ('offerId' in offerSpend))
	const offerLabel = isSingleView && `'${offerSpend?.offer?.name ?? ''}' [id: ${offerSpend?.offerId ?? ''}]`
	const dayLabel = offerSpend?.day

	return <>
		<Modal show={show} onHide={onClose} size="xl" className={'modal-with-sticky scroll'}>
			<Modal.Header className={'modal-header--sticky'} closeButton>
				<Modal.Title>
					{
						isSingleView ?
							`${t(ALL_LANG_KEY.offer_spend_crud_modal.title_by_offer, { offer: offerLabel, date: dayLabel })}` :
							`${t(ALL_LANG_KEY.offer_spend_crud_modal.title_by_offer_total, { date: dayLabel })}`
					}
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<OfferSpendByOfferDetailsTable
					items={offerSpend?.agg ?? []}
					skip={skip}
					showDateColumn={viewBy === EOfferSpendByOfferView.Month}
				/>
			</Modal.Body>

			<Modal.Footer className={'modal-footer--sticky'}>
				<ToolPanel flow="<-" width={'100%'}>
					<Button variant="secondary" onClick={onClose}>{`${t(ALL_LANG_KEY.offer_spend_crud_modal.btn_close)}`}</Button>
				</ToolPanel>

			</Modal.Footer>
		</Modal>
	</>
}
